
const LoadingAnimation = ({ size = 100, color = "#3b82f6" }) => {
   
  return (
    <div className="flex justify-center items-center h-screen">
    <div className="w-16 h-16 border-4 border-slate-700 border-t-transparent rounded-full animate-spin" />
  </div>
  );
};

export default LoadingAnimation;